export const CENTER_GET_TASK = 'CENTER_GET_TASK';
export const CENTER_RECEIVE_TASK = 'CENTER_RECEIVE_TASK';
export const CENTER_REJECT_TASK = 'CENTER_REJECT_TASK';
